import {IHttpTransport, _RequestEnvelope, Status} from './core/types';
import {FetchTransport} from './core/FetchTransport';
import {throwForStatusCode} from './core/errors';

export class AdminApiClient {
    private _baseUrl: string;
    private _transport: IHttpTransport;

    constructor(baseUrl: string, transport?: IHttpTransport) {
        this._baseUrl = baseUrl.replace(/\/$/, '');
        this._transport = transport ?? new FetchTransport();
    }

    setTransport(transport: IHttpTransport): void {
        this._transport = transport;
    }

    async call<TResponse>(
        request: _RequestEnvelope<TResponse>,
        authToken?: string
    ): Promise<TResponse> {
        const {_endpoint, _resultCodeMap} = request;

        const body: Record<string, unknown> = {};
        for (const key of Object.keys(request)) {
            if (!key.startsWith('_')) {
                body[key] = (request as Record<string, unknown>)[key];
            }
        }

        const headers: Record<string, string> = {};
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
        }

        const raw = (await this._transport.post(
            `${this._baseUrl}/${_endpoint}`,
            body,
            headers
        )) as Record<string, unknown>;

        const status = raw['Status'] as Status | undefined;
        if (status && status.Code !== 0) {
            throwForStatusCode(status.Code, status.Message);
        }

        delete raw['Status'];

        if (_resultCodeMap !== null && typeof raw['Result'] === 'number') {
            raw['Result'] = _resultCodeMap[raw['Result'] as number] ?? 'Unknown';
        }

        return raw as TResponse;
    }
}
